var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#7A57DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.092 8.263v-4.93L6 10.123l4.092-1.86Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.092 12.543v-4.28L6 10.123l4.092 2.42Zm0-4.28 4.092 1.86-4.092-6.79v4.93Z",
    fill: "#A5A9C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.092 8.264v4.279l4.092-2.42-4.092-1.86Z",
    fill: "#7277A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.092 13.318 6 10.9l4.092 5.767v-3.349Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m14.187 10.9-4.095 2.418v3.349l4.095-5.767Z",
    fill: "#A5A9C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.1679020a48f347ebaf35d6eca7bd394d.svg";
export { ForwardRef as ReactComponent };